import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'
import getHeadersformdata from './getHeaderFormdata'
import { pageValue } from '../constants/constant'

const COMMON_ERROR = "Something went wrong, please try again later.";

export const DsrAction = (params = {}) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_DSR
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  try {
    const response = await axios(options);
    if (response?.status === 200 || response?.status === 201) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    if (error?.response) {
      if (error?.response?.status === 400) {
        const errorData = error?.response?.data?.errors;

        if (errorData) {
          // Helper function to get error message from array or string
          // const getErrorMessage = (field) => {
          //   return Array.isArray(field) ? field[0] : field;
          // };

          // Handles error codes singluar or multiple by using the key array of errorData and mapping the error notifications
          errorData?.map(i => notify.error(i));

          // Handle other errors or general error message
          // if (!errorData.employee_code && !errorData.mobile_number && !errorData.dsr_id && !errorData?.pincode) {
          //   if (typeof errorData === 'string') {
          //     notify.error(errorData);
          //   } else {
          //     notify.error("An error occurred. Please try again.");
          //   }
          // }
        }

        return error.response;
      } else {
        errorHandler(error);
      }
    } else {
      errorHandler(error);
    }
  }
};

export const DsrListAction = (page, page_size, query) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.DSR_NAMES_LIST + `?page_size=${page_size}&page=${page}${query ? query : ""}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_MSR_NAME_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
    });
};

export const DsrPincodeAction = (pincode = null) => dispatch => {
  // If pincode is provided, add it to the URL as query parameter
  const baseUrl = process.env.REACT_APP_API_URL + Url.DSR_PINCODE;
  const url = pincode ? `${baseUrl}?pincode=${pincode}` : baseUrl;

  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_MSR_NAME_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error; // Re-throw to handle in component
    });
};

export const DsrIsActiveViewAction = (params = {}, id) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.ACTIVE_DSR}/${id}`
  let options = Object.assign({ method: 'PATCH' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.PUT_ACTIVE_MSR, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      const errorMessage = error.response.data.msg;
      if (errorMessage) {
        notify.error(errorMessage);
      } else {
        errorHandler(error)
      }
    }
  })
}

export const UpdateDsrAction = (params = {}, id) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.UPDATE_DSR}/${id}`
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null);
  options.headers = getHeaders();
  options.url = url;

  return axios(options)
    .then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        return resp;
      } else {
        return null;
      }
    })
    .catch(error => {
      if (error?.response) {
        const status = error?.response?.status;
        if (status >= 202 && status <= 400) {
          const errorData = error?.response?.data?.errors;
          if (errorData) {
            errorData?.map(i => notify.error(i));
          }
          return;
        }

        // For all other statuses (outside 202–400)
        errorHandler(error);
        return error.response;
      }else {
        notify.error(COMMON_ERROR);
      }
    });
};

export const DsrNameAction = (id) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.DETAILS_DSR}/${id}`
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_MSR_NAME, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const dowloaddsrlistAction = (page, query) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.DSR_LIST_EXCEL + `?page_size=${pageValue.pageSize}&page=${page}${query ? query : ""}`;
  const headers = getHeaders();
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob();
    } else {
      notify.error('Failed to download file');
      return null
    }
  } catch (error) {
    errorHandler(error)
  }
};